<template>
  <div>

    <!-- cart start -->
    <div class="cart-area mg-top-90">

      <div class="container">

        <div v-if="busy" class="d-flex justify-content-center">
          <div class="spinner-grow text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <doughnut-chart v-show="!busy" :data="dataChart" :options="dataOptions"></doughnut-chart>

        <div class="row mt-2">
          <div class="col">
            <h5>Summary</h5>
          </div>
            <div class="col col-auto">
               <i class="fa fa-refresh fa-2x text-primary" @click="chart_load()"></i>
            </div>

          <div class="col">
            <h5 class="text-right">{{ order.yourref }}</h5>
          </div>
        </div>


        <div class="ba-all-page-inner mb-4 mt-0">

          <ul>
            <li><a class="clear-after" href="#">Order Value <span class="bg-btn mr-0">{{ order.value | currency("")
            }}</span></a></li>
            <li><a class="clear-after" href="#">Invoices & Credits <span class="bg-btn text-warning mr-0">{{ order.spent
              | currency("") }}</span></a></li>
            <li v-if="order.reclaim != '0.00'"><a class="clear-after" href="#">VAT Reclaim <span
                  class="bg-btn text-info mr-0">{{ order.reclaim | currency("") }}</span></a></li>
            <li><a class="clear-after" href="#">Remaining <span class="bg-btn text-primary mr-0">{{ order.remaining |
              currency("") }}</span></a></li>
            <!-- <li><a href="#">Overspent <span class="bg-btn text-danger">{{ 0.00 | currency("") }}</span></a></li> -->
          </ul>
        </div>
      </div>

    </div>

    <!-- cart End -->
    <!-- transaction start -->
    <div class="transaction-area ">
      <div class="container">

        <div class="section-title">

          <!-- <h3 class="title">Invoices</h3> -->
          <!-- <a href="transaction.html">View All</a> -->
        </div>
        <ul class="transaction-inner">
          <li @click="$router.push('/details?id=' + $route.query.id)" class="ba-single-transaction">
            <div class="thumb">
              <img src="assets/img/icon/36.png" alt="img">
            </div>
            <div class="details">
              <h5>Statement</h5>
              <span class="small text-warning">GBP {{ order.value | currency('') }}</span>
              <!-- <p><i class="fa fa-calendar"></i> {{ $moment().format("DD/MM/YY") }} <i class="fa fa-clock-o pr-2"></i> {{ $moment().format("HH:mm") }}</p> -->

              <h5 :class="parseFloat(order.remaining) >= 0 ? 'credit' : 'debit'" class="text-end mt-n23px">
                {{ order.remaining | currency('') }}
                <span class="small" v-html="balance_text(order.remaining)"></span>
                <p><i class="fa fa-arrow-circle-right"></i></p>
              </h5>
            </div>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "Home",
  data() {
    return {
      busy: false,
      date_at: {
        startDate: this.$moment().startOf('year').format('YYYY-MM-DD'),
        endDate: this.$moment().endOf('year').format('YYYY-MM-DD')
      },
      order: {},
      palette: [
        {
          name: "remaining",
          backgroundColor: "rgba(46,184,92,0.1)",
          borderColor: "#2eb85c",
          pointHoverBackgroundColor: "#2eb85c",
          borderWidth: 2,
        },
        {
          name: "credit",
          backgroundColor: "rgba(71,153,235,0.1)",
          borderColor: "#6c757d",
          pointHoverBackgroundColor: "#549c60",
          borderWidth: 2,
        },
        {
          name: "invoice",
          backgroundColor: "rgba(249,177,21,0.1)",
          borderColor: "#f9b115",
          pointHoverBackgroundColor: "#f9b115",
          borderWidth: 2,
        },
        {
          name: "overspent",
          backgroundColor: "rgba(229,83,83,0.1)",
          borderColor: "#e55353",
          pointHoverBackgroundColor: "#e55353",
          borderWidth: 2,
        },
        {
          name: "reclaim",
          backgroundColor: "rgba(32, 168, 216, 0.1)",
          borderColor: "#20a8d8",
          pointHoverBackgroundColor: "#20a8d8",
          borderWidth: 2
        },
        // PURPLE
        // {
        //   name: "forecast",
        //   // backgroundColor: "rgba(249,177,21,0.1)",
        //   // borderColor: "#f9b115",
        //   backgroundColor: "rgba(249,177,21,0.1)",
        //   borderColor: "#f9b115",
        //   pointHoverBackgroundColor: "#f9b115",
        //   borderWidth: 2,
        // },
        // INFO
        // backgroundColor: "rgba(32, 168, 216, 0.1)",
        //   borderColor: "#20a8d8",
        //   pointHoverBackgroundColor: "#20a8d8",
        //GREY
        //          backgroundColor: "rgba(71,153,235,0.1)",
        //           borderColor: "#6c757d",
        //           pointHoverBackgroundColor: "#549c60",
        //           borderWidth: 2,

      ],
      dataChart: {
        labels: [],
        datasets: [
          { labels: [], backgroundColor: [], data: [] },
          { labels: [], backgroundColor: [], data: [] }
        ]
      },
      dataOptions: {
        datalabels: {
          display: false,
        },
        hole: {
          display: true,
          text: ""
        },
        title: {
          display: true,
          fontSize: 16,
          text: "",
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            boxWidth: 10,
            display: true,
            fontSize: 10,
          },
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];

              let raw = data.raw[tooltipItem.index];
              return raw.key + " : " + raw.value;

              // var total = dataset.data.reduce(function (
              //   previousValue,
              //   currentValue,
              //   currentIndex,
              //   array
              // ) {
              //   return previousValue + currentValue;
              // });
              // var currentValue = dataset.data[tooltipItem.index];
              // var percentage = currentValue; //parseFloat((currentValue / total) * 100 + 0.5).toFixed(2);

              // let raw = dataset.raw[tooltipItem.index];
              // return raw.key + " : " + raw.value;
              // return percentage + "%";
            },
            //   afterLabel: function(tooltipItem, data) {
            //     let raw =
            //       data.datasets[tooltipItem.datasetIndex].raw[
            //         tooltipItem.index
            //       ];
            //     // console.log(raw);
            //     return [
            //       "Name: " + raw.key,
            //       "Value: " + raw.value,
            //     ];
            //   }
          },
        },
        onClick: function (evt, item) {
          var activePoints = this.getElementsAtEvent(evt);
          var firstPoint = activePoints[0];
        }
      }
    }
  },
  mounted() {
    this.order_load(0)
    this.chart_load(0)
  },
  computed: {
    ref() {
      return this.$route.query.ref
    },
    date_range() {
      return this.$route.query.date_at
    }
  },
  watch: {
    async "$route.query"() {
      await this.order_load(0)
      await this.chart_load(0)
    }
  },
  methods: {
    balance_text(amount) {
      let v = parseFloat(amount)
      console.log(v)
      if (v == 0) {
        return ""
      }
      if (v > 0) {
        return ""
      }
      if (v < 0) {
        return ""
      }
    },
    async order_load(l) {

      this.busy = true
      let variables = {
        id: this.$route.query.id,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query orders(
              $id: String
            ) {
              orders(
                id: $id
              ) {
                id
                yourref
                description
                value
                spent
                reclaim
                remaining
                slac
                placed_at
                eventcode
                eventname
                value
                spent
                credit
                remaining
                notify_limit
                rows
              }
            }
          `,
          variables,
        });
        if (response.data.orders.length > 0) {
          this.order = response.data.orders[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false
    },
    async chart_load(offset, limit, page) {
      if (!this.$route.query.id) { return}

      this.busy = true

      let variables = {
        id: this.$route.query.id,
      };

      try {
        const response = await this.$apollo.query({
          query: gql`
              query chart_orderspent(
                $id: String
              ) {
                chart_orderspent(
                  id: $id
                ) {
                  labels
                  datasets {
                    data
                  }
                  raw {
                    key
                    value
                  }
                }
              }
            `,
          variables,
        });

        this.dataChart = response.data.chart_orderspent;

        // COLOUR THE WHEEL
        if (this.dataChart) {
          for (var i = 0; i < this.dataChart.raw.length; i++) {
            let colour = this.palette.find(o => o.name == "remaining");

            let item = this.dataChart.raw[i];
            let key = item.key.toLowerCase()
            switch (key) {
              case "forecast":
              case "reclaim":
              case "remaining":
              case "overspent":
                colour = this.palette.find(o => o.name == key);
                break;
              default:
                if (parseInt(item.value) > 0) {
                  colour = this.palette.find(o => o.name == "invoice");
                } else if (parseInt(item.value) < 0) {
                  colour = this.palette.find(o => o.name == "credit");
                }
            }
            if (!this.dataChart.datasets[0].backgroundColor) { this.dataChart.datasets[0].backgroundColor = [] }
            this.dataChart.datasets[0].backgroundColor.push(colour.borderColor);
          }

          if (this.order) {

            let text = ""
            if (this.order.ref) {
              text += this.order.ref
              if (this.order.description) {
                text += " - " + this.order.description
              }
            } else {
              text += this.order.slac
              if (this.order.eventname) {
                text += " - " + this.order.eventname
              }
            }
            this.dataOptions.title.text = text

            text = "GBP "
            if (this.order.value == '0.00') {
              text += this.order.remaining
            } else {
              text += this.order.value
            }
            this.dataOptions.hole.text = text
          }
        }

      } catch (error) {
        console.log(error);
      }

      this.busy = false

    }
  },



}
</script>